// Dependencies
import { all, call, takeEvery, fork, put } from "@redux-saga/core/effects";

// Action Types
import {
    DEVICE_MODEL_CREATE_REQUEST,
    DEVICE_MODEL_UPDATE_REQUEST,
    DEVICE_MODEL_GET_REQUEST,
    DEVICE_MODEL_SEARCH_UNIT_TYPES,
} from 'Redux/actionTypes';

// Actions
import {
    deviceModelCreateResult,
    deviceModelGetResult,
    deviceModelUpdateResult,
    deviceModelSearchUnitTypesResult
} from 'Redux/actions';

// Helpers
import { clientMutation, clientQuery } from 'Core/data/GraphQLApi';
import { endpoints } from 'Core/defaultValues';
import { ExceptionManager } from 'Core/logManager';

function* createDeviceModel({ payload }) {
    try {

        let QUERY = `
            mutation createDeviceModel ($manufacturerId: Int!, $unitTypeId: Int!, $name: String!, $product: String!, $system: String!, $network: String!, $maxGeofences: Int!, $input: Int, $output: Int, $battery: Boolean, $initialBattery: Int, $versionSim: Boolean, $ota: Boolean, $sms: Boolean, $starter: Boolean, $driverBehavior: Boolean, $analytic: Boolean, $motion: Boolean, $obd2Alerts: Boolean, $hoursEnable: Boolean, $odometerEnable: Boolean, $promiles: Boolean, $comData: Boolean, $pressurePro: Boolean, $vbus: Boolean, $jbus: Boolean, $tow: Boolean, $ttu: Boolean, $cariq: Boolean, $carbEnable: Boolean, $tso: Boolean, $deviceModelGeofence: DeviceModelGeofenceInput, $alertTypeIds: [Int]) {
                result: createDeviceModel (manufacturerId: $manufacturerId, unitTypeId: $unitTypeId, name: $name, product: $product, system: $system, network: $network, maxGeofences: $maxGeofences, input: $input, output: $output, battery: $battery, initialBattery: $initialBattery, versionSim: $versionSim, ota: $ota, sms: $sms, starter: $starter, driverBehavior: $driverBehavior, analytic: $analytic, motion: $motion, obd2Alerts: $obd2Alerts, hoursEnable: $hoursEnable, odometerEnable: $odometerEnable, promiles: $promiles, comData: $comData, pressurePro: $pressurePro, vbus: $vbus, jbus: $jbus, tow: $tow, ttu: $ttu, cariq: $cariq, carbEnable: $carbEnable, tso: $tso, deviceModelGeofence: $deviceModelGeofence, alertTypeIds: $alertTypeIds) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );
        yield put(deviceModelCreateResult(data?.result))

    } catch (exc) {
        yield put(deviceModelCreateResult())
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/redux/saga",
            "createDeviceModel"
        )
    }
}

function* updateDeviceModel({ payload }) {
    try {
        let QUERY = `
            mutation updateDeviceModel ($id: String!, $unitTypeId: Int!, $name: String!, $product: String!, $system: String!, $network: String!, $maxGeofences: Int!, $input: Int, $output: Int, $battery: Boolean, $initialBattery: Int, $versionSim: Boolean, $ota: Boolean, $sms: Boolean, $starter: Boolean, $driverBehavior: Boolean, $analytic: Boolean, $motion: Boolean, $obd2Alerts: Boolean, $hoursEnable: Boolean, $odometerEnable: Boolean, $promiles: Boolean, $comData: Boolean, $pressurePro: Boolean, $vbus: Boolean, $jbus: Boolean, $tow: Boolean, $ttu: Boolean, $cariq: Boolean, $carbEnable: Boolean, $tso: Boolean, $deviceModelGeofence: DeviceModelGeofenceInput, $alertTypeIds: [Int]) {
                result: updateDeviceModel (id: $id, unitTypeId: $unitTypeId, name: $name, product: $product, system: $system, network: $network, maxGeofences: $maxGeofences, input: $input, output: $output, battery: $battery, initialBattery: $initialBattery, versionSim: $versionSim, ota: $ota, sms: $sms, starter: $starter, driverBehavior: $driverBehavior, analytic: $analytic, motion: $motion, obd2Alerts: $obd2Alerts, hoursEnable: $hoursEnable, odometerEnable: $odometerEnable, promiles: $promiles, comData: $comData, pressurePro: $pressurePro, vbus: $vbus, jbus: $jbus, tow: $tow, ttu: $ttu, cariq: $cariq, carbEnable: $carbEnable, tso: $tso, deviceModelGeofence: $deviceModelGeofence, alertTypeIds: $alertTypeIds) {
                    id
                    name
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(deviceModelUpdateResult(data?.result))

    } catch (exc) {
        yield put(deviceModelUpdateResult())
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/redux/saga",
            "updateDeviceModel"
        )
    }
}

function* getDeviceModel({ payload }) {
    try {
        let QUERY = `
            query getDeviceModel ($id: Int!) {
                result: getDeviceModel (id: $id) {
                    id
                    unitTypeId
                    name
                    product
                    geofence
                    system
                    network
                    input
                    output
                    ota
                    sms
                    starter
                    driverBehavior
                    battery
                    initialBattery
                    versionSim
                    analytic
                    promiles
                    comData
                    pressurePro
                    vbus
                    jbus
                    obd2Alerts
                    motion
                    tow
                    ttu
                    tso
                    hoursEnable
                    odometerEnable
                    cariq
                    carbEnable
                    deviceModelGeofence {
                        deviceModelId
                        geofence
                        maxGeofence
                        polygon
                        maxPoint
                        square
                        circle
                    }
                    deviceModelAlertTypes{
                        id
                        alertTypeId
                        alertType {
                            id
                            name
                            code
                            parentId
                        }
                    }
                }
            }
        `;


        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(deviceModelGetResult(data?.result));

    } catch (exc) {
        yield put(deviceModelGetResult());
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/redux/saga",
            "getDeviceModel"
        )
    }
}

function* searchUnitTypes({ payload }) {
    try {
        let QUERY = `
            query searchUnitTypes ($conditions: [UnitTypeSearchInput], $sort: [UnitTypeSortInput], $limit: Int, $offset: Int) {
                result: searchUnitTypes (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                    }
                }
            }
        `;


        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["manufacturer_name"],
                        terms: [payload],
                        exact: true,
                    }
                ],
                sort: {
                    field: "name",
                    order: "ASC"
                },
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(deviceModelSearchUnitTypesResult(data?.result?.items));

    } catch (exc) {
        yield put(deviceModelSearchUnitTypesResult([]));
        ExceptionManager(
            exc,
            "Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/redux/saga",
            "searchUnitTypes"
        )
    }
}

function* watchMethods() {
    yield takeEvery(DEVICE_MODEL_CREATE_REQUEST, createDeviceModel);
    yield takeEvery(DEVICE_MODEL_UPDATE_REQUEST, updateDeviceModel);
    yield takeEvery(DEVICE_MODEL_GET_REQUEST, getDeviceModel);
    yield takeEvery(DEVICE_MODEL_SEARCH_UNIT_TYPES, searchUnitTypes);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}